import { useResponsiveContainer } from 'src/contexts/ResponsiveContainerContext'

import { TranscriptToolbarMobile } from './TranscriptToolbarMobile'
import { TranscriptToolbar as TranscriptToolbarDesktop } from './TranscriptToolbar'

export const TranscriptToolbar = () => {
    const { isMediumContainer, containerWidth } = useResponsiveContainer()

    if (isMediumContainer) {
        return <TranscriptToolbarMobile />
    }

    return <TranscriptToolbarDesktop containerWidth={containerWidth} />
}
